import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapPin } from '@fortawesome/pro-solid-svg-icons';
import {
  useAppSelector,
  useAppDispatch,
  showLabelsSelector,
  setShowLabels,
  allowLabelsSelector,
  labelsSelector,
} from '../../../store';

import './DisplayOptions.scss';

export function DisplayOptions() {
  const dispatch = useAppDispatch();
  const showLabels = useAppSelector(showLabelsSelector);
  const allowLabels = useAppSelector(allowLabelsSelector);
  const labels = useAppSelector(labelsSelector);

  if (allowLabels && labels.length > 0) {
    return (
      <div className={`map-display-option ${showLabels ? 'visible' : 'hidden'}`}>
        <label htmlFor="labels">
          <FontAwesomeIcon icon={faMapPin} />
          <span className="display-option-name">Locations</span>
        </label>
        <input
          className="options-checkbox"
          id="labels"
          type="checkbox"
          checked={showLabels}
          onChange={() => dispatch(setShowLabels(!showLabels))}
        />
      </div>
    );
  }
}
